<template>
  <div class="">
    <v-container class="ml-10 mr-10">
      <p class="display-1 mt-7">정품 인증 코드 관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정품 인증 코드에 대한 내역을 확인하고 관리합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        생성된 인증 코드에 대한 이력과 함께 보증 기간, 인증 상태등 설정이 가능합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        엑셀 다운로드가 가능하며, QR코드 인쇄 기능을 사용할 수 있습니다.
      </p>

      <ManageAuthCodeSearch ref="searchComponent"></ManageAuthCodeSearch>
      <ManageAuthCodeList ref="listComponent"></ManageAuthCodeList>
    </v-container>
  </div>
</template>

<script>
import ManageAuthCodeSearch from "@/components/authservice/authcode/ManageAuthCodeSearch.vue";
import ManageAuthCodeList from "@/components/authservice/authcode/ManageAuthCodeList.vue";

export default {
  data: () => ({}),
  components: {
    ManageAuthCodeSearch,
    ManageAuthCodeList,
  },
};
</script>
